<template>
	<div class='page greyBg'>
	<mu-refresh-control :refreshing="refreshing" :trigger="trigger" @refresh="refresh"/>
		<pageTitle title='我的点评'></pageTitle>
		<div class='rank whiteBg'>
			<div class='left'>
				<div class='title'>{{rank}}</div>
				<div class='desc'>{{rankHint}}</div>
			</div>
			<img src='../../../static/user/comment/rank.png' />
		</div>
		<tabList @tabChange='tabChange' :list='tabList' :value='tabValue'/>
		<div v-if='tabValue == 0'>
			<ul class='needComment' >
				<li @click='goComment(index)' class='whiteBg' v-for='(comment,index) in commentList[0]'>
					<img :src='comment.ImgUrl'>
					<div class='middle overPoints'>
						<h3 class='overPoints'>{{comment.HotelName}}</h3>
						<mu-icon value="room" color="#A5A5A5" :size='13' />
						{{comment.Address}}
					</div>
					<div class='right'>
						我要点评
					</div>
				</li>
			</ul>
			<div class='loading' v-if='loadState[0].loading'>
				<img src="../../../static/LoadingBest.gif" />
			</div>
			<loadListTail mainTitle='暂时没有待点评订单哦，快来互动吧！' mainIcon='noComment' :noMore='loadState[0].stop' :isLoading='loadState[0].loading' :overZero='commentList[0].length > 0'  />
		</div>
		<div v-else>
			<ul class='commented greyBg'  >
				<li class='whiteBg'  v-for='(comment,index) in commentList[1]'>
					<div class='commentTop'>
						<div class='left'>
							<span class='auditing' v-if='comment.IsAudit == "0"'>审核中</span>
							<span class='audited' v-if='comment.IsAudit == "1"'>已生效</span>
							{{comment.Score}}分
						</div>
						<div class='right'>{{comment.CreateTime}}</div>
					</div>
					<div class='mainComments'>
						{{comment.CommentContent}}
					</div>
					<div class='softGreyBg commentReply' v-if='comment.ReplyContent'>
						<div class='commentTop'>
							<div class='left'>店长回复：</div>
							<div class='right'>{{comment.ReplyTime}}</div>
						</div>
						{{comment.ReplyContent}}
					</div>
					<div class='addComments' v-if='comment.CommentAppend'>
						<div class='commentTop'>
							<div class='left'>
								追加评论：
								<span class='auditing' v-if='comment.CommentAppend.IsAudit == "0"'>审核中</span>
								<span class='audited' v-if='comment.CommentAppend.IsAudit == "1"'>已生效</span>
							</div>
							<div class='right'>{{comment.CommentAppend.CreateDate | toDay}}</div>
						</div>
						{{comment.CommentAppend.CommentContent}}
						<div class='softGreyBg commentReply' v-if='comment.CommentAppend.IsReply'>
							<div class='commentTop'>
								<div class='left'>店长回复：</div>
								<div class='right'>{{comment.CommentAppend.ReplyDate | toDay}}</div>
							</div>
							{{comment.CommentAppend.ReplyContent}}
						</div>
					</div>
					<div class='softGreyBg hotel'>
						<img :src='comment.HotelImg' />
						<div class='msg overPoints'>
							<h3 class='overPoints'>{{comment.HotelName}}</h3>
							<mu-icon value="room" color="#A5A5A5" :size='13' />
							{{comment.HotelAddress}}
						</div>
					</div>
					<div class='option'>
						<span @click='goAppend(index)' v-if='!comment.CommentAppend && comment.IsAudit == "1"'>追加点评</span>
						<span @click='goDelete(comment.CommentID)'>删除</span>
					</div>
				</li>
			</ul>
			<div class='loading' v-if='loadState[1].loading'>
				<img src="../../../static/LoadingBest.gif" />
			</div>
			<loadListTail mainTitle='暂时没有已点评订单哦，快来互动吧！' mainIcon='noComment' :noMore='loadState[1].stop' :isLoading='loadState[1].loading' :overZero='commentList[1].length > 0'  />
		</div>
		<mu-toast v-if="toast" id="alertline" v-bind:message="hintMes" @close="hideToast" />
    <!--弹出框 选择是否-->
    <mu-dialog :open="dialog" title="" @close="dialog=false">
      <div style="color:#666666">
        尊敬的客户，您确定删除该条评论吗？
      </div>
      <table style="width:100%">
        <tr>
          <td align="center">
            <mu-flat-button slot="actions" @click="dialog=false" primary="" label="取消" style="background-color:#cccccc ;color:white  " />
          </td>
          <td align="center">
            <mu-flat-button slot="actions" @click="deleteTopic" label="确定" style="background-color:#27BA69 ;color:white " />
          </td>
        </tr>
      </table>
    </mu-dialog>
	</div>
</template>

<style lang="less" scoped>
	@import '../../assets/theme.less';
	@import '../../assets/comments.less';

	.page{
		padding-bottom:1rem;
	}
	.rank{
		margin:0.2rem 0;
		display:flex;
		.left{
			display:flex;
			justify-content:center;
			flex-direction:column;
			padding:0.6rem 0 0.6rem 0.6rem;
			width:5.5rem;
			.title{
				color:@darkOrange;
				font-size:0.36rem;
				font-weight:600;
			}
			.desc{
				color:#999999;
				font-size:0.24rem;
			}
		}
		img{
			height:2rem;
			width:2rem;
			margin:auto 0;
		}
	}
	.needComment{
		li{
			display:flex;
			padding:0.2rem;
			border-bottom:1px solid #e4e4e4;
			img{
				width:1.2rem;
				height:1rem;
				margin:auto 0.2rem auto 0;
			}
			.middle{
				width:4.2rem;
				font-size:0.26rem;
				h3{
					-webkit-margin-before: 0;
					-webkit-margin-after: 0;
					font-size:0.32rem;
					color:#333333;
				}
				i{
					position:relative;
					top:2px;
				}
			}
			.right{
				color:@primaryColor;
				padding:0.01rem 0.05rem;
				font-size:0.26rem;
				border:1px solid @primaryColor;
				margin:auto 0 auto 0.2rem;
			}
		}
	}
	.auditing{
		background-color:@darkOrange;
	}
	.audited{
		background-color:@primaryColor;
	}
	.commented{
		li{
			margin-top:1em;
			padding:1em;
			>.commentTop{
				.left{
					color:@darkOrange;
					font-size:0.26rem;
					span{
						color:#fff;
						font-size:0.22rem;
						border-radius:4px;
						margin-right:0.1rem;
						padding:0.05rem 0.1rem;
					}
				}
			}
			.mainComments{
				margin:0.3rem 0;
				font-size:0.28rem;
				line-height:0.38rem;
			}
			.hotel{
				display:flex;
				margin-top:0.2rem;
				border-radius:4px;
				img{
					max-height:1.3rem;
				}
				.msg{
					font-size:0.22rem;
					margin:auto 0.2rem;
					h3{
						-webkit-margin-before: 0;
						-webkit-margin-after: 0;
						font-size:0.28rem;
						color:#333333;
						margin-bottom:0.08rem;
					}
					i{
						position:relative;
						top:2px;
					}
				}
			}
			.option{
				margin-top:0.4rem;
				text-align:right;
				span{
					font-size:0.24rem;
					color:#666666;
					border:1px solid #cccccc;
					border-radius:2px;
					padding:0.05rem 0.1rem;
					margin-left:0.1rem;
				}
			}
			.addComments{
				.commentTop{
					.left{
						span{
							color:#fff;
							border-radius:4px;
							margin-right:0.1rem;
							padding:0.05rem 0.1rem;
						}
					}
				}
			}
		}
		li:first-child{
			margin-top:0;
		}
	}
</style>

<script>
	import { mapGetters, mapMutations } from 'vuex'
	import pageTitle  from '../../components/pageTitle.vue'
	import tabList from '../../components/tabTitle/tabList.vue'
	import loadListTail from '../../components/loadListTail.vue'
	import api from '../../api/index.js'
	import Scroll from '../../utils/loading'

	export default {
		data () {
			return {
				tabList:[
					{
						title:'待点评',
						value:0
					},
					{
						title:'已点评',
						value:1
					}
				],
				tabValue: 0,
				//卡号
				cardNo:'',
				//等级
				rank:'',
				//升级提示
				rankHint:'',
				commentList:[[],[]],
				refreshing: false,
        trigger: null,
        loadState:[
          {
              loading:false,
              stop:false
          },
          {
              loading:false,
              stop:false
          }
      	],
        scroll:null,
				hintMes: '',
      	toast: false,
				dialog:false,
				//当前评论
				currentId:''
			}
		},
		components: {
			pageTitle,tabList,loadListTail
		},
		activated(){
			this.scroll.addHandler()
			if(this.scroll != null){
				this.getUserRank()
				this.initAll()
				console.log('activated')
			}
		},
		mounted(){
			console.log('mounted')
			this.trigger = this.$el
			this.getUserRank()
			this.scroll = Scroll.Create(this,this.getCommentList,10,2)
		},
		deactivated(){
			this.scroll.removeHandler()
		},
		computed:{
      ...mapGetters([
        'g_UserInfo'
      ]),
		},
		methods: {
			//清空两种数据
			initAll(){
				this.commentList = [[],[]]
				this.scroll.refreshAll()
			},
			initData(){
				//重新获取等级
				this.getUserRank()
        //清空显示数据
				this.commentList.splice(this.tabValue, 1, [])
        //初始化本页控制数据、分页参数
        this.scroll.refresh()
    	},
			tabChange(val){
				var oldType = this.tabValue
				if(this.loadState[oldType].loading || this.refreshing){
					return
				}
				this.tabValue = val
				this.scroll.changeType(val)
			},
			//设置等级信息
			setRankMsg(topicCount){
				//获取会员评论次数--5条内为点评新手、6-30条内为点评达人、30条以上为点评大师
				if (topicCount <= 5)
				{
					this.rank = "点评新手";
					this.rankHint = '还差' + (6 - topicCount) + '条升级为“点评达人”'
				}
				else if (topicCount > 5 && topicCount <= 30)
				{
					this.rank = "点评达人";
					this.rankHint = '还差' + (31 - topicCount) + '条升级为“点评大师”'
				}
				else{
					this.rank = "点评大师";
					this.rankHint = '您已升至最高等级'
				}
			},
			//获取评论等级
			getUserRank(){
				var params = new this.URLSearchParam();
				params.append('cardNo',this.$route.query.cardNo);
				this.$http.post(api.getTopicCount(),params.toParam()).then((res) => {
					if(res.Result){
						var topicCount = res.Data
						this.setRankMsg(topicCount)
					}
					else{
						if(res.Message == "未登录")
							this.$router.push({ path: '/user/Login' })
					}
				})
			},
			//获取待评论列表
			getCommentList(){
				var that = this
				var type = this.tabValue
				var params = new this.URLSearchParam();
				params.append('type',type)
      	params.append('pageIndex', this.pageParam[type].index)
				params.append('pageSize', 10)
				params.append('cardNo',this.$route.query.cardNo)
				return new Promise(function(resolve, reject) {
					that.$http.post(api.GetCommentList(), params.toParam()).then((res) => {
						if(res.Result){
							console.log(res.Data)
							var temp = res.Data
							resolve(temp.length)
							that.commentList.splice(type, 1, that.commentList[type].concat(temp))
						}
						else{
							resolve(null)
						}
					})
				})
			},
			//跳转评论页
			goComment(commentIndex){
				var comment = this.commentList[0][commentIndex]
				//return
				this.$router.push({ 
					path: '/comments/writeComments',
					query: {
						Address:comment.Address,
						CheckInTime:comment.CheckInTime,
						CheckOutTime:comment.CheckOutTime,
						HotelCode:comment.HotelCode,
						HotelName:comment.HotelName,
						ImgUrl:comment.ImgUrl,
						OrderId:comment.OrderId,
						RoomId:comment.RoomId,
						RoomType:comment.RoomType,
						cardNo:this.$route.query.cardNo
					}
				})
			},
			//跳转追评页
			goAppend(appendIndex){
				var append = this.commentList[1][appendIndex]
				//return
				this.$router.push({ 
					path: '/comments/appendComments',
					query: {
						CommentID: append.CommentID,
						HotelName: append.HotelName,
						Address: append.HotelAddress,
						RoomType: append.RoomType,
						CheckInTime: append.CheckInTime,
						CheckOutTime: append.CheckOutTime
					}
				})
			},
			//删除评论
			deleteTopic(topicId){
				this.dialog = false
				var that = this
				var params = new this.URLSearchParam()
				params.append('topicId',this.currentId)
				this.$http.post(api.DeleteTopic(), params.toParam()).then((res) => {
					this.hintMes = res.Message
					this.showToast()
					if(res.Result){
						setTimeout(function(){
							that.initData()
						},1200)
					}
				})
			},
			goDelete(commentId){
				this.currentId = commentId
				this.dialog = true
			},
			refresh () {
				this.refreshing = true
				setTimeout(() => {
					this.refreshing = false
					this.initData()
				}, 2000)
    	},
			showToast() {
				this.toast = true
				if (this.toastTimer) clearTimeout(this.toastTimer)
				this.toastTimer = setTimeout(() => { this.toast = false }, 2000)
			},
			hideToast() {
				this.toast = false
				if (this.toastTimer) clearTimeout(this.toastTimer)
			},
		}
	}
</script>


// WEBPACK FOOTER //
// myComments.vue?27cff752